export enum EventAttendanceOptionsEnum {
  Pending = '9073f07d-e561-4450-961f-7de2cabfcfe7',
  Accepted = '045c83c2-e3c0-4c67-8964-a2e4542747d4',
  Declined = '794c71aa-1188-40fa-a1ca-8b624f6823b8',
	Waitlisted = 'a9d7e67d-7ed6-3ed6-9384-cbd478e690d8',
}
